import appColors from "./common/colors";

const antdCustomTheme = {
  token: {
    colorPrimary: appColors.primary,
    borderRadius: 8,
    paddingInline: 20,
  },
};

export default antdCustomTheme;
